import { Component, Input, OnInit } from '@angular/core';
import { PaymentEquation } from '../../../payment/model/payment-equation';

@Component({
  selector: 'pioneer-payment-calculation',
  templateUrl: './payment-calculation.component.html'
})
export class PaymentCalculationComponent implements OnInit {

  @Input() currency: string;
  @Input() paymentEquation: PaymentEquation;
  @Input() isHotelApprover: boolean;
  @Input() showCurrencyNote: boolean;
  @Input() fundCurrency: String;
  @Input() applyOoiv: boolean;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/components/payment-calculation/payment-calculation.component.ts